import React from 'react';
import './App.css';
import 'animate.css';
import { Header } from './layouts/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
function App() {
  return (
     <BrowserRouter basename="/templates">
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
      </Routes>
    </BrowserRouter>
  );
}
export default App;
